import React, { useContext, useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import DashboardTextboxComponent from "./DashboardTextboxComponent";
import StatusProjectNotes from "./StatusProjectNotes";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";

function DashboardTextboxContainer(props) {
  const creds = useContext(CredsContext).creds;
  const [currentContent, setCurrentContent] = useState();
  let projectObject = JSON.parse(sessionStorage.getItem("projectObject"));

  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);

  useEffect(() => {
    if (projectObject.newsfeedid != "") {
      const requestString =
        authString +
        '<Read type="NewsfeedMessage" limit="1000" method="equal to"><NewsfeedMessage><newsfeedid>' +
        projectObject.newsfeedid +
        "</newsfeedid><title>PROJECT NOTES</title></NewsfeedMessage></Read></request>";
      Tools.fetchPost(requestString, urlString, "NewsfeedMessage").then(
        (rawMessages) => {
          if (rawMessages.xml.length > 0) {
            const nfMessageArray = Tools.xmlToArray(rawMessages.xml);
            let lastMessage = nfMessageArray[nfMessageArray.length - 1].content;

            lastMessage = lastMessage.replace(/<br>/g, "\n");
            lastMessage = lastMessage.replace(/<\/?p>/g, "");
            lastMessage = lastMessage.replace(/<\/?strong>/g, "");
            setCurrentContent(lastMessage);
          }
        },
      );
    }
  }, []);

  return props.statusVersion ? (
    <StatusProjectNotes message={currentContent} />
  ) : (
    <DashboardTextboxComponent defaultMessage={currentContent} />
  );
}

export default DashboardTextboxContainer;

DashboardTextboxContainer.propTypes = { statusVersion: PropTypes.bool };
